import CommonUtils from '@/libs/common-utils';
import axios from 'axios';

const TIMEOUT = 200000;
const onRequestSuccess = async (config: any) => {
  const epochSeconds = Math.floor(new Date().getTime() / 1000);
  const visitorId = await CommonUtils.getBrowserFingerprint();
  const token = localStorage.getItem('jhi-authenticationToken') || sessionStorage.getItem('jhi-authenticationToken');
  if (token) {
    if (!config.headers) {
      config.headers = {};
    }
    let jwt = null;
    try {
      jwt = CommonUtils.deobfuscate(token);
      jwt = jwt.replace(/^"|"$/g, '');
      const tokenJson = {
        jwt: jwt,
        epochSeconds: epochSeconds,
      };
      const obfuscatedToken = CommonUtils.obfuscate(tokenJson);
      config.headers.Authorization = `H8 ${obfuscatedToken}`;
    } catch (error) {
      console.error(error);
      localStorage.removeItem('jhi-authenticationToken');
      sessionStorage.removeItem('jhi-authenticationToken');
    }
  }
  if (visitorId) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers['x-visitor-id'] = visitorId;
  }
  config.timeout = TIMEOUT;
  config.url = `${SERVER_API_URL}${config.url}`;
  return config;
};
const setupAxiosInterceptors = (onUnauthenticated: any, onServerError: any) => {
  const onResponseError = (err: any) => {
    console.log(err);
    const status = err.status || err.response.status;
    if (status === 403 || status === 401) {
      onUnauthenticated();
    }
    if (status >= 500) {
      onServerError();
    }
    return Promise.reject(err);
  };

  if (axios.interceptors) {
    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use(res => res, onResponseError);
  }
};

export { onRequestSuccess, setupAxiosInterceptors };
